import { createApp } from 'vue'  
import App from './App.vue'  
import router from './router'  
import Vant from 'vant';
import 'vant/lib/index.css'; 
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);   // 必须加载UTC插件

// 创建实例但不立即挂载
const app = createApp(App);

// 先注册全局属性
app.config.globalProperties.$dayjs = dayjs;

// 再挂载路由和插件
app.use(router);
app.use(Vant);

// 异步加载配置并初始化
// 异步加载配置JSON文件
fetch('/config.json')
  .then(response => response.json())
  .then(config => {
    app.config.globalProperties.$config = config;
    
    // 在配置加载完成后挂载应用
    app.mount('#app');
}).catch(error => {
    console.error('加载配置失败：', error);
    // 可在此处设置回退配置
    app.config.globalProperties.$config = {
        API_BASE_URL: 'http:// fallback.url'
    };
    app.mount('#app');
});




